import { useCallback, useState } from 'react'
import { useMounted } from '../../../Hooks/useMounted'
import { v4 as uuid } from 'uuid'
import { useAppDispatch } from '../../../Hooks/useAppDispatch'
import { LabsActions } from '../StoreAdapter'
import { LabSchema } from '../../../Schema/LabSchema'
import { ServiceLocator } from '../../../Services/ServiceLocator'
import { LabsAPI } from '../../../Services/API/LabsAPI'

export const useAddLab = () => {
  const dispatch = useAppDispatch()
  const mounted = useMounted()

  const [processing, setProcessing] = useState(false)
  const [errors, setErrors] = useState<
    Record<string, string> | Record<string, string>[]
  >(null)
  const [errorMessage, setErrorMessage] = useState<string>(null)

  const addLab = useCallback(
    async (schema: LabSchema): Promise<LabSchema> => {
      setProcessing(true)
      return ServiceLocator.resolve(LabsAPI)
        .createEntity(schema)
        .then((schema) => {
          dispatch(LabsActions.addOne(schema))
          if (mounted.current) {
            setProcessing(false)
            setErrors(null)
            setErrorMessage(null)
          }
          return schema
        })
        .catch((err) => {
          if (mounted.current) {
            setProcessing(false)
            setErrorMessage(err?.response?.data?.errorMessage)
            setErrors(err?.response?.data?.errors)
            throw err
          }
          return null
        })
    },
    [dispatch, mounted],
  )

  return {
    processing,
    errors,
    errorMessage,
    addLab,
  }
}
